import { render } from "./add-videos-modal-editor.vue?vue&type=template&id=cef9c3ca"
import script from "./add-videos-modal-editor.vue?vue&type=script&lang=js"
export * from "./add-videos-modal-editor.vue?vue&type=script&lang=js"
script.render = render

export default script